export default __webpack_public_path__ + "static/media/member-1.b499a685.png";